<div class="row">
    <div class="col-md-12 text-center text-copyright">
        <p class="animalo retardo-6" data-animate-effect="fadeIn">
        Copyright &copy; 2019 | Design4Me | Bootstrap Responsive Web Design.
        </p>
    </div>
</div>